import { apiBudgetUpdate } from './../Types/QuoteRequest/Api';
import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'

const endpoint = `${apiUrl.stable}/orcamentos`

export const getFirstAccess = () => {

  const headers = {
    ...jsonWebToken.header
  }

  const url = `${endpoint}/primeiro-acesso`

  return axios.get(url, { headers })
}

export const getQuotationList = (quotationId: number) => {

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    quotationId
  }

  const url = `${endpoint}/listar`

  return axios.get(url, { headers, params })
}

export const getQuotationById = (companyQuotationId: number) => {

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    companyQuotationId
  }

  const url = `${endpoint}/obter`

  return axios.get(url, { headers, params })
}

export const saveBudgetInfo = (data: apiBudgetUpdate) => {

  const headers = {
    ...jsonWebToken.header
  }


  const url = `${endpoint}/salvar`

  return axios.post(url, data, { headers })
}

export const updateBudgetInfo = (data: apiBudgetUpdate) => {

  const headers = {
    ...jsonWebToken.header
  }


  const url = `${endpoint}/atualizar`

  return axios.put(url, data, { headers })
}

export const getSpreadsheetInfo = (quotationId) => {

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    quotationId
  }

  const url = `${endpoint}/gerar`

  return axios.get(url, { headers, params })
}


export default {
  getFirstAccess,
  saveBudgetInfo,
  getQuotationById,
  updateBudgetInfo
}

